import { render, staticRenderFns } from "./IcoAi.vue?vue&type=template&id=3bb4ef14"
import script from "./IcoAi.vue?vue&type=script&lang=js"
export * from "./IcoAi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports